// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grid[data-v-418ae095]{display:grid;grid-template-columns:calc(50% - .26vw) calc(50% - .26vw);margin:.521vw auto;grid-gap:.521vw}.one-column[data-v-418ae095]{grid-template-columns:100%}", ""]);
// Exports
module.exports = exports;
